<template>
  <div>
    <q-btn class="q-mt-xs" round flat icon="transfer_within_a_station" padding="none" size="lg" color="indigo"
           :disable="!$store.state.roles.some(v=>['admin','Buy_User'].includes(v))"
           @click="showGoodsBuySale(goodsInfo)">
      <q-tooltip>
        گزارش خرید و فروش سالیانه یک کالا
      </q-tooltip>
    </q-btn>

    <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="lg" color="red"
           v-if="goodsInfo.Goods_SaleStatus!==50101"
           :disable="!$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))"
           @click="showGoodsStateDialog(goodsInfo)">
      <q-tooltip>
        {{ goodsInfo.General_Name }}
      </q-tooltip>
    </q-btn>
    <q-btn round
           flat
           icon="attach_money"
           size="lg"
           padding="none"
           color="indigo"
           @click="showChangePriceDialog(goodsInfo)"
           v-if="$store.state.roles.some(v=>['admin','can_change_goods_price'].includes(v))">
      <q-tooltip>
        قیمت گذاری کالا
      </q-tooltip>
    </q-btn>
    <q-btn round icon="privacy_tip" flat padding="none" size="lg"
           :color="goodsInfo.Goods_Stock===0?'red-10':'indigo'"
           @click="showCatexDialog(goodsInfo)">
      <q-tooltip>
        کارتکس کالا
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs" round flat icon="lock" padding="none" size="lg" color="red"
           v-if="!isSelectionForm && goodsInfo.Goods_SaleStatus!==50101"
           :disable="!$store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))"
           @click="showGoodsStateDialog(goodsInfo)"
    >
      <q-tooltip>
        {{ goodsInfo.General_Name }}
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round flat icon="auto_fix_normal"
           padding="none"
           size="lg"
           color="purple"
           @click="showGoodsEditDialog(goodsInfo)"
           v-if="!isSelectionForm && $store.state.roles.some(v=>['admin','can_edit_goods_exists'].includes(v))">
      <q-tooltip>
        اصلاح موجودی کالا
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round flat icon="warehouse"
           padding="none"
           size="lg"
           color="indigo"
           @click="showWarehouseHandling(goodsInfo)"
           v-if="!isSelectionForm && $store.state.roles.some(v=>['admin','can_warehouse-handling'].includes(v))">
      <q-tooltip>
        انبارگردانی
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round flat icon="pan_tool"
           padding="none"
           size="lg"
           color="blue-grey-14"
           @click="showGoodsStateDialog(goodsInfo)"
           v-if="!isSelectionForm && goodsInfo.Goods_SaleStatus===50101 && $store.state.roles.some(v=>['admin','can_change_product_state'].includes(v))">
      <q-tooltip>
        تغییر وضعیت فروش کالا
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round flat icon="link"
           padding="none"
           size="lg"
           color="brown"
           @click="showDependency(goodsInfo, false)"
           v-if="goodsInfo.Goods_SaleStatus===50101 && $store.state.roles.some(v=>['admin','can_set_goods_sale_chains'].includes(v))">
      <q-tooltip>
        تعیین وابستکی محصول
      </q-tooltip>
      <q-badge v-if="goodsInfo.dependencies" floating color="red" text-color="white" rounded
               :label="JSON.parse(goodsInfo.dependencies).length"/>
    </q-btn>
    <q-btn class="q-mt-xs"
           v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
           round
           flat
           icon="person_off"
           padding="none"
           size="lg"
           :color="'blue-grey-14'"
           @click="showCustomerNoWorking(goodsInfo)">
      <q-tooltip>
        لیست طرف معامله که کالا را خریداری ننموده اند
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round
           flat
           icon="person"
           padding="none"
           size="lg"
           :color="'blue-grey-14'"
           v-if="$store.state.roles.some(v=>['admin','can_see_customer_list'].includes(v))"
           @click="showCustomerWorking(goodsInfo)">
      <q-tooltip>
        لیست طرف معامله که کالا را خریداری نموده اند
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round
           flat
           icon="insights"
           padding="none"
           size="lg"
           :color="'blue-grey-14'"
           v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
           @click="showPriceTrace(goodsInfo)">
      <q-tooltip>
        تغییرات قیمتی
      </q-tooltip>
    </q-btn>
    <q-btn class="q-mt-xs"
           round
           flat
           icon="bar_chart"
           padding="none"
           size="lg"
           :color="'blue-grey-14'"
           v-if="$store.state.roles.some(v=>['admin','can_see_yearly_report'].includes(v))"
           @click="showGoodsDashBoard(goodsInfo)">
      <q-tooltip>
        داشبورد فروش کالا
      </q-tooltip>
    </q-btn>

    <q-dialog v-model="productPriceTrace" maximized full-width>
      <ProductPriceTraceList :product-info="selectedProduct"/>
    </q-dialog>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProduct"/>
    </q-dialog>
    <q-dialog maximized v-model="showCartex">
      <GoodsCartex :goods-info="goodsInfo"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsEditDialog">
      <GoodsStore :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="warehouseDialog">
      <WarehouseHandling :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog :maximized="$q.screen.lt.md" v-model="goodsStateDialog">
      <ChangeState :goods-info="selectedProduct" :group-info="null" @close-dialog="changedGoodsState"/>
    </q-dialog>
    <q-dialog maximized seamless v-model="goodsDependencyDialog">
      <ProductDependencyManage :is-select-form="isSelectionForm" :goods-info="this.selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="showReserveDialog" :maximized="$q.screen.lt.md">
      <ReserveExiList :goods-info="selectedProduct"/>
    </q-dialog>
    <q-dialog maximized v-model="customerDialog">
      <CustomersList :items="customerList" :is-dialog="true"
                     :is-only-search-list="true"
                     :title="customerListDialogTitle"/>
    </q-dialog>
    <q-dialog v-model="changeGoodsPriceDialog"
              :maximized="$q.screen.lt.md">
      <GoodsPrice @change-price="updatePrice"
                  :product-info="selectedProduct"/>
    </q-dialog>
    <q-dialog v-model="productGoodsDashboard" maximized full-width>
      <SaleYearlyDashboard :goods-info="selectedProduct" :is-dialog="true"/>
    </q-dialog>
    <q-dialog v-model="goodsBuySaleDialog" >
      <GoodsBuySaleInYearReport :goods-info="selectedProduct" />
    </q-dialog>

  </div>
</template>

<script>
import {mapActions} from "vuex";
import WarehouseHandling from "@/components/store/WarehouseHandling.vue";
import ChangeState from "@/components/products/ChangeState.vue";
import CustomersList from "@/components/customers/CustomersList.vue";
import GoodsPrice from "@/components/products/GoodsPrice.vue";
import ProductDependencyManage from "@/components/productInfo/ProductDependencyManage.vue";
import ReserveExiList from "@/components/products/ReserveExiList.vue";
import GoodsCartex from "@/components/store/GoodsCartex.vue";
import ProductPriceTraceList from "@/components/products/ProductPriceTraceList.vue";
import GoodsStore from "@/components/store/GoodsStore.vue";
import GoodsBuySaleInYearReport from "@/components/productInfo/GoodsBuySaleInYearReport.vue";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: 'ProductActions',
  components: {
    ProductDetail,
    GoodsBuySaleInYearReport,
    GoodsStore,
    ProductPriceTraceList,
    GoodsCartex,
    ReserveExiList,
    SaleYearlyDashboard: () => import("@/components/dashboard/SaleYearlyDashboard.vue"),
    ProductDependencyManage,
    GoodsPrice,
    CustomersList,
    ChangeState,
    WarehouseHandling,
  },
  props: {
    goodsInfo: {
      type: Object,
      default: () => undefined,
      required: true
    },
    isSelectionForm: {
      type: Boolean,
      default: () => false,
      required: true
    }
  },
  data() {
    return {
      selectedProduct: undefined,
      goodsStateDialog: false,
      editProductDialog: false,
      changeGoodsPriceDialog: false,
      showProductDetails: false,
      goodsEditDialog: false,
      warehouseDialog: false,
      goodsDependencyViewOnly: false,
      goodsDependencyDialog: false,
      selectedGroup: undefined,
      customerListDialogTitle: undefined,
      customerDialog: false,
      productPriceTrace: false,
      productGoodsDashboard: false,
      showCartex: false,
      showReserveDialog: false,
      customerList: [],
      addProductDialog: false,
      goodsBuySaleDialog:false,
    }
  },
  methods: {
    ...mapActions({
      getCustomerList: 'Products/getGoodsCustomerRelation',
      getLastGoodsBuy: 'Products/getLastGoodsBuy',
      setGoodsBuySale: 'Products/getGoodsBuySaleMonthInCurrentYear'
    }),
    showGoodsBuySale(goodsInfo) {
      this.selectedProduct = goodsInfo
      this.goodsBuySaleDialog = true
    },
    updatePrice(args) {
      this.$emit('goodsPriceUpdated', args)
      this.changeGoodsPriceDialog = false
    },
    showGoodsStateDialog(row) {
      this.selectedProduct = row
      this.goodsStateDialog = true
    },
    showEditProductDialog(product) {
      this.selectedProduct = product
      this.editProductDialog = true
    },
    showChangePriceDialog(product) {
      this.selectedProduct = product
      this.changeGoodsPriceDialog = true
    },
    showProductDetailsDialog(row) {
      this.selectedProduct = row;
      this.showProductDetails = true
    },
    showGoodsEditDialog(row) {
      this.selectedProduct = row;
      this.goodsEditDialog = true;
    },
    showWarehouseHandling(row) {
      this.selectedProduct = row;
      this.warehouseDialog = true;
    },
    showDependency(row, viewOnly) {
      this.selectedProduct = row
      this.goodsDependencyViewOnly = viewOnly
      this.isSelectionForm = viewOnly
      this.goodsDependencyDialog = true
    },
    showCustomerNoWorking(row) {
      this.selectedGroup = row;
      this.customerListDialogTitle = `لیست طرف معامله که کالای ${row.Goods_Name} را تاکنون نخریده اند `
      this.getCustomerList({
        goodsId: row.Goods_ID,
        flag: 0
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
    showCustomerWorking(row) {
      this.customerListDialogTitle = `لیست طرف معامله که کالای ${row.Goods_Name} را تاکنون خریده اند `
      this.getCustomerList({
        goodsId: row.Goods_ID,
        flag: 1
      }).then((res) => {
        this.customerList = res.filter(item => item.CsSpe_ID === 2)
        this.customerDialog = true
      })
    },
    showPriceTrace(rowInfo) {
      this.selectedProduct = rowInfo
      this.productPriceTrace = true
    },
    showGoodsDashBoard(rowInfo) {
      this.selectedProduct = rowInfo
      this.productGoodsDashboard = true
    },
    showCatexDialog(row) {
      this.selectedProduct = row
      this.showCartex = true;
    },
    changedGoodsState() {
      this.goodsStateDialog = false
    },
  }
}
</script>